import { useState } from "react";
import { connect } from "react-redux";
import Cookies from "cookies-js";
import { getURLPath, getDomain } from "../../../../../helpers/Tools";
import * as types from "../../../../../constants/actionTypes";
import { logUI } from "../../../../../api/andyliticsApi";
import { LinkCTA } from "../../../index";
import './heading_lang_cta.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateLang: (language) => dispatch({ type: types.MYCHART_DATATILE_LANG_UPDATE, language: language }),
    };
};

export const HeadingLangCTA = connect(mapStateToProps, mapDispatchToProps)(({
    screenBreakPoint, updateLang
}) => {

    const viewInEnglish = 'View in English';
    const viewInSpanish = 'Ver en Español';

    const [localizationlabel, setLocalizationlabel] = useState(navigator && navigator.language && navigator.language.indexOf('es') === 0 ? viewInEnglish : viewInSpanish);

    const onLocalizationChangeClick = (e) => {
        var myDomain = getDomain();
        var localization = '';
        if (Cookies.get('BSWLOCAL'))
            localization = Cookies.get('BSWLOCAL');
        if (localization && localization.length > 0) {
            if (localization === 'espanol') {
                Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
                setLocalizationlabel(viewInSpanish);
            }
            else {
                Cookies.set('BSWLOCAL', 'espanol', { expires: Infinity, path: '/', domain: myDomain });
                setLocalizationlabel(viewInEnglish);
            }
        }
        else {
            Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
            localization = 'english'
            setLocalizationlabel(viewInSpanish);
        }
        updateLang(localization);
        const localeLog = (localization && localization.length > 0) ? ((localization === 'english') ? 'espanol' : 'english') : 'unknown';
        logUI("MBHWeb.HeadingLangCTA.Btn.LocaleChange." + localeLog, new Date(), getURLPath(), '');
    }

    return (
        <div className="mybswh-heading-lang-cta">
            <LinkCTA
                as={<button type="button"></button>}
                onClick={onLocalizationChangeClick}
            >
                {localizationlabel}
            </LinkCTA>
        </div>
    )
})